import React from "react";
import styled from "styled-components";

const Container = styled.div`
  margin: 0;
  font-family: sans-serif;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  a {
    background-color: transparent;
  }
  b,
  optgroup,
  strong {
    font-weight: 700;
  }
  h1 {
    margin: 0.67em 0;
  }
  textarea {
    overflow: auto;
  }
  kbd,
  samp {
    font-size: 1em;
  }
  table {
    border-spacing: 0;
    border-collapse: collapse;
  }
  td,
  th {
    padding: 0;
  }
  .img-thumbnail,
  body {
    background-color: #fff;
  }
  *,
  :after,
  :before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  html {
    font-size: 10px;
    -webkit-tap-highlight-color: transparent;
  }
  body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
  }
  a {
    color: #337ab7;
    text-decoration: none;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: inherit;
    font-weight: 500;
    line-height: 1.1;
    color: inherit;
    margin-top: 35px;
    margin-bottom: 10px;
    word-wrap: break-word;
    word-break: break-word;
  }
  h2,
  h3,
  h4 {
    border-bottom: 1px solid #ccc;
  }
  h1 {
    font-size: 36px;
  }
  h2 {
    font-size: 30px;
  }
  h3 {
    font-size: 24px;
  }
  h4 {
    font-size: 18px;
  }
  h5 {
    font-size: 14px;
  }
  h6 {
    font-size: 12px;
    margin-top: 20px;
  }
  p {
    margin: 0 0 10px;
  }
  address,
  blockquote .small,
  blockquote footer,
  blockquote small,
  dd,
  dt {
    line-height: 1.42857143;
  }
  table {
    background-color: transparent;
  }
  legend,
  kbd {
    padding: 2px 4px;
    font-size: 90%;
  }
  caption,
  th {
    text-align: left;
  }
  kbd,
  samp {
    font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
  }
  table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
  table > tbody > tr > td,
  table > tbody > tr > th,
  table > tfoot > tr > td,
  table > tfoot > tr > th,
  table > thead > tr > td,
  table > thead > tr > th {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
  }
  table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 2px solid #ddd;
  }
  table > caption + thead > tr:first-child > td,
  table > caption + thead > tr:first-child > th,
  table > colgroup + thead > tr:first-child > td,
  table > colgroup + thead > tr:first-child > th,
  table > thead:first-child > tr:first-child > td,
  table > thead:first-child > tr:first-child > th {
    border-top: 0;
  }
  table > tbody > tr > td,
  table > tbody > tr > th,
  table > tfoot > tr > td,
  table > tfoot > tr > th,
  table > thead > tr > td,
  table > thead > tr > th {
    padding: 5px;
  }
  table,
  table > tbody > tr > td,
  table > tbody > tr > th,
  table > tfoot > tr > td,
  table > tfoot > tr > th,
  table > thead > tr > td,
  table > thead > tr > th {
    border: 1px solid #ddd;
  }
  table > thead > tr > td,
  table > thead > tr > th {
    border-bottom-width: 2px;
  }
  table > tbody > tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  table > tbody > tr:hover,
  table > tbody > tr.active > td,
  table > tbody > tr.active > th,
  table > tbody > tr > td.active,
  table > tbody > tr > th.active,
  table > tfoot > tr.active > td,
  table > tfoot > tr.active > th,
  table > tfoot > tr > td.active,
  table > tfoot > tr > th.active,
  table > thead > tr.active > td,
  table > thead > tr.active > th,
  table > thead > tr > td.active,
  table > thead > tr > th.active {
    background-color: #f5f5f5;
  }

  .alert,
  .thumbnail {
    margin-bottom: 20px;
  }
  .alert .alert-link,
  .close {
    font-weight: 700;
  }
  .jumbotron > hr {
    border-top-color: #d5d5d5;
  }
  .container .jumbotron,
  .container-fluid .jumbotron {
    padding-right: 15px;
    padding-left: 15px;
    border-radius: 6px;
  }
  .jumbotron .container {
    max-width: 100%;
  }
  @media screen and (min-width: 768px) {
    .jumbotron {
      padding-top: 48px;
      padding-bottom: 48px;
    }
    .container .jumbotron,
    .container-fluid .jumbotron {
      padding-right: 60px;
      padding-left: 60px;
    }
    .jumbotron .h1,
    .jumbotron h1 {
      font-size: 63px;
    }
  }
  .thumbnail {
    padding: 4px;
    line-height: 1.42857143;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    -webkit-transition: border 0.2s ease-in-out;
    -o-transition: border 0.2s ease-in-out;
    transition: border 0.2s ease-in-out;
  }
  .thumbnail a > img,
  .thumbnail > img {
    margin-right: auto;
    margin-left: auto;
  }
  a.thumbnail.active,
  a.thumbnail:focus,
  a.thumbnail:hover {
    border-color: #337ab7;
  }
  .thumbnail .caption {
    padding: 9px;
    color: #333;
  }
  .alert {
    padding: 15px;
    border: 1px solid transparent;
    border-radius: 4px;
  }
  .alert h4 {
    margin-top: 0;
    color: inherit;
  }
  .alert > p,
  .alert > ul {
    margin-bottom: 0;
  }
  .alert > p + p {
    margin-top: 5px;
  }
  .alert-dismissable,
  .alert-dismissible {
    padding-right: 35px;
  }
  .alert-dismissable .close,
  .alert-dismissible .close {
    position: relative;
    top: -2px;
    right: -21px;
    color: inherit;
  }
  .modal,
  .modal-backdrop {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .alert-success {
    color: #3c763d;
    background-color: #dff0d8;
    border-color: #d6e9c6;
  }
  .alert-success hr {
    border-top-color: #c9e2b3;
  }
  .alert-success .alert-link {
    color: #2b542c;
  }
  .alert-info {
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
  }
  .alert-info hr {
    border-top-color: #a6e1ec;
  }
  .alert-info .alert-link {
    color: #245269;
  }
  .alert-warning {
    color: #8a6d3b;
    background-color: #fcf8e3;
    border-color: #faebcc;
  }
  .alert-warning hr {
    border-top-color: #f7e1b5;
  }
  .alert-warning .alert-link {
    color: #66512c;
  }
  .alert-danger {
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
  }
  .alert-danger hr {
    border-top-color: #e4b9c0;
  }
  .alert-danger .alert-link {
    color: #843534;
  }

  body,
  figure {
    margin: 0;
  }
  html {
    font-family: sans-serif;
    -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
  }
  a {
    background-color: transparent;
  }
  b,
  optgroup,
  strong {
    font-weight: 700;
  }
  h1 {
    margin: 0.67em 0;
  }
  textarea {
    overflow: auto;
  }
  kbd,
  samp {
    font-size: 1em;
  }
  table {
    border-spacing: 0;
    border-collapse: collapse;
  }
  td,
  th {
    padding: 0;
  }
  .img-thumbnail,
  body {
    background-color: #fff;
  }
  *,
  :after,
  :before {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  html {
    font-size: 10px;
    -webkit-tap-highlight-color: transparent;
  }
  body {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
  }
  a {
    color: #337ab7;
    text-decoration: none;
  }
  address,
  blockquote .small,
  blockquote footer,
  blockquote small,
  dd,
  dt {
    line-height: 1.42857143;
  }
  table {
    background-color: transparent;
  }
  legend,
  kbd {
    padding: 2px 4px;
    font-size: 90%;
  }
  caption,
  th {
    text-align: left;
  }
  kbd,
  samp {
    font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
  }
  table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
  }
  table > tbody > tr > td,
  table > tbody > tr > th,
  table > tfoot > tr > td,
  table > tfoot > tr > th,
  table > thead > tr > td,
  table > thead > tr > th {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
  }
  table > thead > tr > th {
    vertical-align: bottom;
    border-bottom: 2px solid #ddd;
  }
  table > caption + thead > tr:first-child > td,
  table > caption + thead > tr:first-child > th,
  table > colgroup + thead > tr:first-child > td,
  table > colgroup + thead > tr:first-child > th,
  table > thead:first-child > tr:first-child > td,
  table > thead:first-child > tr:first-child > th {
    border-top: 0;
  }
  table > tbody > tr > td,
  table > tbody > tr > th,
  table > tfoot > tr > td,
  table > tfoot > tr > th,
  table > thead > tr > td,
  table > thead > tr > th {
    padding: 5px;
  }
  table,
  table > tbody > tr > td,
  table > tbody > tr > th,
  table > tfoot > tr > td,
  table > tfoot > tr > th,
  table > thead > tr > td,
  table > thead > tr > th {
    border: 1px solid #ddd;
  }
  table > thead > tr > td,
  table > thead > tr > th {
    border-bottom-width: 2px;
  }
  table > tbody > tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  table > tbody > tr:hover,
  table > tbody > tr.active > td,
  table > tbody > tr.active > th,
  table > tbody > tr > td.active,
  table > tbody > tr > th.active,
  table > tfoot > tr.active > td,
  table > tfoot > tr.active > th,
  table > tfoot > tr > td.active,
  table > tfoot > tr > th.active,
  table > thead > tr.active > td,
  table > thead > tr.active > th,
  table > thead > tr > td.active,
  table > thead > tr > th.active {
    background-color: #f5f5f5;
  }

  html,
  body {
    font-family: "Segoe UI", Tahoma, Helvetica, sans-serif;
    height: 100%;
  }
  button,
  a {
    color: #337ab7;
    cursor: pointer;
  }

  .inheritance .level0:before,
  .inheritance .level1:before,
  .inheritance .level2:before,
  .inheritance .level3:before,
  .inheritance .level4:before,
  .inheritance .level5:before {
    content: "↳";
    margin-right: 5px;
  }

  .inheritance .level0 {
    margin-left: 0em;
  }

  .inheritance .level1 {
    margin-left: 1em;
  }

  .inheritance .level2 {
    margin-left: 2em;
  }

  .inheritance .level3 {
    margin-left: 3em;
  }

  span.parametername,
  span.paramref,
  span.typeparamref {
    font-style: italic;
  }

  .hljs {
    display: inline;
    background-color: inherit;
    padding: 0;
  }

  table {
    margin-bottom: 10px;
  }
  table p {
    margin-bottom: 0;
  }
  table a {
    display: inline-block;
  }

  .inheritance h5,
  .inheritedMembers h5 {
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
  }
  .codewrapper {
    position: relative;
  }

  html,
  body {
    font-family: "Segoe UI", Tahoma, Helvetica, sans-serif;
    height: 100%;
  }
  button,
  a {
    color: #337ab7;
    cursor: pointer;
  }

  .inheritance .level0:before,
  .inheritance .level1:before,
  .inheritance .level2:before,
  .inheritance .level3:before,
  .inheritance .level4:before,
  .inheritance .level5:before {
    content: "↳";
    margin-right: 5px;
  }

  .inheritance .level0 {
    margin-left: 0em;
  }

  .inheritance .level1 {
    margin-left: 1em;
  }

  .inheritance .level2 {
    margin-left: 2em;
  }

  .inheritance .level3 {
    margin-left: 3em;
  }

  span.parametername,
  span.paramref,
  span.typeparamref {
    font-style: italic;
  }

  .hljs {
    display: inline;
    background-color: inherit;
    padding: 0;
  }

  table {
    margin-bottom: 10px;
  }
  table p {
    margin-bottom: 0;
  }
  table a {
    display: inline-block;
  }

  .inheritance h5,
  .inheritedMembers h5 {
    padding-bottom: 5px;
    border-bottom: 1px solid #ccc;
  }
  .codewrapper {
    position: relative;
  }

  .alert h5 {
    text-transform: uppercase;
    font-weight: bold;
    margin-top: 0;
  }

  .alert h5:before {
    position: relative;
    top: 1px;
    display: inline-block;
    font-family: "Glyphicons Halflings";
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin-right: 5px;
    font-weight: normal;
  }

  .alert-info h5:before {
    content: "\\e086";
  }

  .alert-warning h5:before {
    content: "\\e127";
  }

  .alert-danger h5:before {
    content: "\\e107";
  }

  &&& pre {
    font-size: 12px;
  }

  img {
    max-width: 500px;
  }

  blockquote {
    padding: 10px 20px;
    margin: 0 0 20px;
    font-size: 17.5px;
    border-left: 5px solid #eee;
  }
`;

export interface IMarkdownProps {
  content: React.ReactNode;
  className?: string;
}

class Markdown extends React.Component<IMarkdownProps> {
  render() {
    return <Container className={this.props.className}>{this.props.content}</Container>;
  }
}

export default Markdown;
